import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import React from "react";
import { useSnackbar } from "notistack";

import RegisterAdmin from "./RegisterAdmin";

const RegisterAdminWithSnackbar = (props) => {
  const snackbar = useSnackbar();
  return React.createElement(RegisterAdmin, { ...props, ...snackbar });
};

const mapStateToProps = (_state) => ({
  // authReducer: state.auth
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterAdminWithSnackbar),
);
